const Login = () => import('@pages/Login')
import WxTokenGetter from '@components/wx-token-getter'
import WxTokenGetter2 from '@components/wx-token-getter-2'

export const auth = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {title: '登录', hideBack: true}
  },
  {
    path: '/get_wechat_token',
    component: WxTokenGetter,
    meta: {auth: false}
  },
  {
    path: '/get_wechat_token_2',
    component: WxTokenGetter2,
    meta: {auth: false}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/auth.route.js